import "./index.css";
import { Info } from "lucide-react";
import { useTranslations } from "../../i18n";
import { clsx } from "clsx";
import { Tooltip } from "../Tooltip";
import { Typography } from "../Typography";
import { Message } from "../Message";
import type { IFormFieldProps } from "./types";
import { useMemo } from "react";
import { Tag } from "../Tag";

export const FormField = ({
  children,
  label,
  description,
  message,
  messageColor = "red",
  required = true,
  className,
  accessory,
  tooltipContent,
  htmlFor,
  color = "layer1",
}: IFormFieldProps) => {
  const { t } = useTranslations();

  const rootClass = clsx("nuco-formField", className);

  const messageJSX = useMemo(() => {
    if (!message) return null;

    return (
      <Message
        className="nuco-formField__message"
        text={message}
        variant={messageColor}
      />
    );
  }, [message, messageColor]);

  return (
    <div className={rootClass}>
      {label && (
        <div className="nuco-formField__top">
          <div className="nuco-formField__label">
            {htmlFor ? (
              <label
                htmlFor={htmlFor}
                className="nuco-formField__labelText nuco-typography--body"
              >
                {label}
              </label>
            ) : (
              <Typography
                as="span"
                className="nuco-formField__labelText"
                text={label}
              />
            )}
            {!required && (
              <Tag color={color} text={t("ui.formField.optional")} />
            )}
            {tooltipContent && (
              <div className="nuco-formField__tooltip">
                <Tooltip content={tooltipContent} placement="right-start">
                  <Info size="1rem" />
                </Tooltip>
              </div>
            )}
            {accessory && (
              <div className="nuco-formField__accessory">{accessory}</div>
            )}
          </div>
          {description && (
            <Typography
              as="div"
              className="nuco-formField__description"
              text={description}
            />
          )}
        </div>
      )}
      <div className="nuco-formField__element">{children}</div>
      {messageJSX}
    </div>
  );
};
